import { SnackbarActionTypes } from "./snackbar.types";

const INITIAL_STATE = {
  open: false,
  message: "",
};

const snackbarReducer = (state = INITIAL_STATE, action) => {
  console.log("Snackbar..........", action);
  switch (action.type) {
    case SnackbarActionTypes.SHOW_SNACKBAR:
      return { open: true, ...action.payload };
    case SnackbarActionTypes.HIDE_SNACKBAR:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default snackbarReducer;
